<template>
    <div>
        <form id="registration-form" role="form">
            <section class="wrapper scrollable">
                <section class="panel panel-default">
                    <div class="panel-heading">
                        <div>
                            <img src="/images/logo.png" alt="proton-logo">
                        </div>
                    </div>
                    <ul class="list-group">
                        <li class="list-group-item form-login-inputs">
                            <span class="login-text">
                                Vaša prijateljica<br>
                                smatra da ste idealna osoba da joj se pridruži na Eucerin putu lepote. Kako biste i Vi krenuli putem lepote, popunite podatke ispod.
                            </span>
                        </li>
                    </ul>
                </section>
            </section>
        </form>
    </div>
</template>

<script>
    import Dashboard from './Dashboard.js';
    export default Dashboard;
</script>
